<template>
    <!-- 添加解读报告 -->
    <a-modal 
        :title="EditDisabled?'修改分析报告':'新建分析报告'"
        :visible="true"
        @ok="toAddReport"
        @cancel="onClose"
        okText="确定"
        cancelText="取消"
        :okButtonProps="{ 
            props: {
                disabled: allowClick
            } 
        }"
    >
        <div class="content">
<!--            <div class="row">-->
<!--                <span>选择城市：</span>-->
<!--                <a-cascader -->
<!--                    class="search-input"-->
<!--                    placeholder="请选择城市"-->
<!--                    :options="cityList" -->
<!--                    @change="onCityChange" -->
<!--                    size="small" -->
<!--                    :loadData="loadCityData"-->
<!--                    v-model="searchCity"-->
<!--                />-->
<!--            </div>-->
            <div class="row">
                <span>创建日期：</span>
                <a-date-picker
                    class="search-input"
                    size="small"
                    placeholder="请输入创建日期"
                    v-model="formData.time"
                    @change="datePickerChange"
                />
            </div>
            <div class="row">
                <span>报告名称：</span>
<!--            </div>-->
<!--            <div class="row">-->
                <a-input
                    v-model="formData.title"
                    placeholder="请输入报告名称（长度35）"
                    @change="reportNameChange"
                />
            </div>
            <div class="row">
                <span>单位：</span>
                <a-input
                        v-model="formData.department"
                        placeholder="请输入单位"
                        @change="reportNameChange"
                />
            </div>
            <div class="row">
                <span>作者：</span>
                <a-input
                        v-model="formData.author"
                        placeholder="请输入作者"
                        @change="reportNameChange"
                />
            </div>
            <div class="row">
                <span>来源：</span>
                <a-input
                        v-model="formData.source"
                        placeholder="请输入来源"
                        @change="reportNameChange"
                />
            </div>
            <div class="row">
                <span>链接：</span>
                <a-input
                        v-model="formData.externalUrl"
                        placeholder="请输入链接"
                        @change="reportNameChange"
                />
            </div>

            <div class="row">
                <span>上传文件(pdf)：</span>
                <a-upload
                        name="file"
                        list-type="picture-card"
                        class="avatar-uploader"
                        :show-upload-list="false"
                        :action="uploadImgUrl"
                        :data="uploadData"
                        :headers="headers"
                        :before-upload="beforeUpload"
                        @change="handleChange"
                >
<!--                    <img v-if="formData.internalUrl" :src="formData.internalUrl" alt="avatar" />-->
                  <div  v-if="formData.internalUrl">
                      <div class="ant-upload-text">
                          {{formData.internalUrl}}
                      </div>
                  </div>
                    <div v-else>
                        <a-icon :type="loading ? 'loading' : 'plus'" />
                        <div class="ant-upload-text">
                            Upload
                        </div>
                    </div>
                </a-upload>
<!--                <el-upload-->
<!--                        class="avatar-uploader quill-img"-->
<!--                        :action="uploadImgUrl"-->
<!--                        name="file"-->
<!--                        :headers="headers"-->
<!--                        :data="uploadData"-->
<!--                        :show-file-list="false"-->
<!--                        :on-success="quillImgSuccess"-->
<!--                        :on-error="uploadError"-->
<!--                        :before-upload="quillImgBefore"-->
<!--                        accept='.pdf'-->
<!--                >-->
<!--                    <i class="el-icon-upload"></i>-->
<!--                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>-->
<!--                    <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>-->
<!--                </el-upload>-->
            </div>
            <div class="row">
                <span>备注：</span>
                <a-input
                        v-model="formData.remark"
                        placeholder="请输入备注"
                        @change="reportNameChange"
                />
            </div>
        </div>
    </a-modal>
</template>

<script>
import UrlApi from "@/utils/UrlApi.js";
import moment from 'moment';
import {getToken} from '@/utils/auth'

function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
}
moment.locale('zh-cn');
export default {
    name:"AddReportModal",
    data () {
        return {
            formData:{
                time:moment().format('YYYY-MM-DD'),
                title:'',
                department:'',
                author:'',
                source:'',
                internalUrl:'',
                externalUrl:'',
                remark:'',
                processId:'',
            },
            headers: {
                Authorization:getToken()
            },
            uploadData:{
                type:'caseLibrary'
            },
            uploadImgUrl: UrlApi.fileUpload , // 上传
            loading: false,
        };
    },
    props:{
        show:Boolean,
        processId:String,
        EditDisabled:Boolean,
    },
    computed:{
        allowClick(){
            let state = true;
            if(this.formData.title){
                state = false;
            }
            if(this.formData.time){
                state = false;
            }
            if(this.formData.department){
                state = false;
            }
            if(this.formData.author){
                state = false;
            }
            if(this.formData.source){
                state = false;
            }
            return state;
        }
    },
    methods: {
        //  初始化 参数
        initData(data){
            this.formData = data
        },


        reportNameChange(){
            if(this.formData.title.length > 35){
                this.formData.title = this.formData.title.slice(0,35);
            }
        },
        // 日期选择
        datePickerChange(momentDate,date){
            this.formData.time = date;
        },
        // 关闭弹窗
        onClose(){
            this.$emit("update:show",false);
        },
        // 新增解读报告
        toAddReport(){
            let params=this.formData
            params.processId = this.processId




            //  判断是新增还是修改   true 修改 false 新增


            if(this.EditDisabled){
                this.$http.post(UrlApi.caseLibraryUpdate,params).then(res => {
                    if(res.data.code==200){
                        this.$message.success(res.data.message);
                        this.$emit("update:show",false);
                        this.$emit("updateShow");
                    }else {
                        this.$message.error(res.data.message)
                    }
                })
            }else {
                this.$http.post(UrlApi.caseLibrarySave,params).then(res => {
                    if(res.data.code==200){
                        this.$message.success(res.data.message);
                        this.$emit("update:show",false);
                        this.$emit("updateShow");
                    }else {
                        this.$message.error(res.data.message)
                    }
                })
            }


            // let token = this.$store.getters.getToken;
            // let userId = this.$store.getters.getUserId;
            // let name = this.$store.getters.getUserName;
            // let reportName = this.reportName;
            // let city = this.searchCity.length ? this.searchCity[this.searchCity.length -1]:"";
            // let timePoint = this.createdDate || moment().format('YYYY-MM-DD');
            // let param = `userId=${userId}&reportName=${reportName}&city=${city}&timePoint=${timePoint}&name=${name}`;
            // let url = UrlApi.addReport;
            // this.$http.post(url,param,{
            //     headers:{
            //         "Authorization":token
            //     }
            // }).then((res)=>{
            //     let message = res.data.message;
            //     if(res.data.success){
            //         this.$message.success(message);
            //         this.$emit("update:show",false);
            //     }else {
            //         this.$message.warning(message);
            //     }
            // })
        },
        // 城市切换
        onCityChange(val){
            this.searchCity = val;
        },
        // load
        loadCityData(city){
            let url = UrlApi.provinceCity;
            const targetOption = city[city.length - 1];
            targetOption.loading = true;
            let params = {
                province: city[0].value
            }
            this.$http.get(url,{
                    params:params
            }).then((res)=>{
                targetOption.loading = false;
                targetOption.children = [];
                res.data.data.map((item)=>{
                    let obj = {
                        label:item.name,
                        value:item.name
                    }
                    targetOption.children.push(obj)
                })
                this.cityList = [...this.cityList];
            })
        },


        handleChange(info) {
            if (info.file.status === 'uploading') {
                this.loading = true;
                return;
            }
            if (info.file.status === 'done') {
                // Get this url from response in real world.
                // console.log(info.file.originFileObj)
                // console.log(info)
                this.formData.internalUrl = info.file.response.data.url;
                this.loading = false;
                // getBase64(info.file.originFileObj, imageUrl => {
                //     this.formData.internalUrl = imageUrl;
                //     this.loading = false;
                // });
            }
        },
        beforeUpload(file) {
            console.log( file.type)
            const isJpgOrPng = file.type === 'application/pdf' || file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
            if (!isJpgOrPng) {
                this.$message.error('请上传pdf文件 或word 文件');
            }
            // const isLt2M = file.size / 1024 / 1024 < 2;
            // if (!isLt2M) {
            //     this.$message.error('pdf文件!');
            // }
            // return isJpgOrPng && isLt2M;
            return isJpgOrPng;
        },


    },
}

</script>
<style lang="less" scoped>
    .content {
        width: 400px;;
        margin: 0 auto;
        .row {
            display: flex;
            flex-flow: row nowrap;
            align-content: center;
            align-items: center;
            justify-content: flex-start;
            margin-bottom: 20px;
            span{
                min-width: 80px;
            }
        }
    }
</style>
<style>
    .avatar-uploader > .ant-upload {
        width: 128px;
        height: 128px;
        overflow: hidden;
    }
    .ant-upload-select-picture-card i {
        font-size: 32px;
        color: #999;
    }

    .ant-upload-select-picture-card .ant-upload-text {
        margin-top: 8px;
        color: #666;
        max-width: 90%;
    }
    .ant-upload-picture-card-wrapper{
        overflow: auto;
    }
</style>